import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { selectSouthTyrolLogo } from "../selectors/partnerLogos.js";
import { useAppSelector } from "../store/hooks.js";
import styles from "../stylesheets/components/full-header-with-logo.module.css";
import headerBaseStyles from "../stylesheets/components/header-base.module.css";
import imageOverlayStyles from "../stylesheets/components/image-overlay.module.css";
import {
  ColorScheme,
  ContainerQueries,
  HeaderImageOverlayGradient,
  HeaderLogoBackground,
  ImagesModuleSettings,
  Language,
  Picture,
  ThreeSizes,
  TranslatedModule,
} from "../types/index.js";
import { getImageModuleWithFixedAspectRatio } from "../utils/utils.js";
import HeaderLogo from "./HeaderLogo.js";
import ImagesModule from "./Modules/ImagesModule.js";
import PartnerLogo from "./PartnerLogo.js";

interface Props {
  imagesModule: TranslatedModule<ImagesModuleSettings>;
  pageId: string;
  queries: ContainerQueries;
  scheme: ColorScheme;
  isHomePage: boolean;
  isPreview: boolean;
  languageId: Language;
  showSouthTyrolLogo: boolean;
  logoBackground: HeaderLogoBackground;
  imageOverlayGradient: HeaderImageOverlayGradient;
  logo: Picture;
  logoSize: ThreeSizes;
  mainPageURL: string | undefined;
}

const FullHeaderWithLogo: FunctionComponent<Props> = ({
  imagesModule,
  isHomePage,
  isPreview,
  pageId,
  queries,
  scheme,
  logo,
  logoSize,
  mainPageURL,
  logoBackground,
  imageOverlayGradient,
  languageId,
  showSouthTyrolLogo,
}) => {
  const southTyrolLogo = useAppSelector((state) =>
    selectSouthTyrolLogo(state, languageId, showSouthTyrolLogo),
  );

  return (
    <div
      className={ClassNames(
        headerBaseStyles.HeaderModule__Inner,
        headerBaseStyles["HeaderModule__Inner--wide"],
        styles["HeaderModule__Inner--fixed-sidebar"],
        styles[
          `HeaderModule__Inner--image-overlay-gradient-${imageOverlayGradient}`
        ],
        {
          [headerBaseStyles["HeaderModule__Inner--is-home"]]: isHomePage,
          [headerBaseStyles["HeaderModule__Inner--preview"]]: isPreview,
          [headerBaseStyles["HeaderModule__Inner--full-height"]]: !isPreview,
        },
        imageOverlayStyles["ImageOverlay__HeaderModule--fixed-sidebar"],
      )}
    >
      <div
        className={ClassNames(styles.HeaderModule__LogosWrapper, {
          [styles["HeaderModule__LogosWrapper--with-partner-logo"]]:
            !!southTyrolLogo,
        })}
      >
        <HeaderLogo
          logo={logo}
          mainPageURL={mainPageURL}
          isPreview={isPreview}
          scheme={scheme}
          logoBackground={logoBackground}
          maxSize={{ width: 300, height: 100 }}
          size={logoSize}
          className={styles.HeaderModule__HeaderLogo}
        />

        {southTyrolLogo && (
          <div className={styles.HeaderModule__LogosWrapperPartner}>
            <PartnerLogo
              partnerLogo={southTyrolLogo}
              size="big"
              className={styles.PartnerLogo}
            />
          </div>
        )}
      </div>

      <ImagesModule
        translatedModule={getImageModuleWithFixedAspectRatio(imagesModule)}
        isPreview={isPreview}
        pageId={pageId}
        queries={queries}
        isActive={false}
        isInsideHeader={true}
        isFirstOnPage={false}
        parentScheme={scheme}
        activeModuleId={undefined}
        fullHeight={!isPreview}
      />
    </div>
  );
};

export default FullHeaderWithLogo;
